import { notification } from "antd";
import type { NotificationInstance } from "antd/es/notification/interface";
import {
  NotificationProvider,
  useNotificationContext,
} from "./NotificationProvider";

export { notification };
export type { NotificationInstance };
export { NotificationProvider, useNotificationContext };
